import { Tooltip } from '@mui/material';
import { Button, ButtonProps } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 32px;
    padding: 0;
    background-color: #f5f5f5;
    min-width: '32px';
    span {
      margin-right: 0;
      margin-left: 0;
    }
  }
` as typeof Button;

interface ActionButtonProps {
  icon: React.ReactNode;
  onClick: () => void;
  title: string;
}

export const ActionButton: React.FC<ActionButtonProps & Omit<ButtonProps, keyof ActionButtonProps | 'intent' | 'label' | 'width'>> = (
  props
) => {
  const { icon, onClick, title, ...rest } = props;

  return (
    <Tooltip title={title} arrow placement='bottom'>
      <div>
        <StyledButton {...rest} label='' startIcon={icon} intent='tertiary' onClick={onClick} width={'32px'} />
      </div>
    </Tooltip>
  );
};
